import React from "react";

const KakaoTalk = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        opacity="0.902"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0.555664C4.29 0.555664 0 4.34166 0 7.54466C0 9.94466 1.558 12.0617 3.931 13.3197L2.933 16.9857C2.844 17.3107 3.213 17.5687 3.496 17.3817L7.873 14.4767C8.242 14.5127 8.618 14.5337 9 14.5337C13.97 14.5337 18 11.4047 18 7.54466C18 4.34166 13.97 0.555664 9 0.555664Z"
        fill="black"
      />
    </svg>
  );
};

export default KakaoTalk;
